var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSenderAllowed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9229e-07 30.2747C2.97954e-07 29.4416 0.67971 28.7662 1.51817 28.7662L72.8724 28.7662C73.7108 28.7662 74.3905 29.4416 74.3905 30.2747V73.2671C74.3905 74.1002 73.7108 74.7756 72.8724 74.7756H1.51817C0.679709 74.7756 -5.66366e-09 74.1002 0 73.2671L2.9229e-07 30.2747Z",
    fill: "#DAE0E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3167 56.8611C36.7923 57.2062 36.105 57.1993 35.5881 56.8436L3.45938 34.7375C2.23931 33.8981 2.84574 32.0192 4.33677 32.0192L70.0545 32.0192C71.5618 32.0192 72.1569 33.9317 70.9058 34.7551L37.3167 56.8611Z",
    fill: "#8599AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.601 37.0982C102.601 46.4604 94.9606 54.0499 85.5355 54.0499C76.1104 54.0499 68.4698 46.4604 68.4698 37.0982C68.4698 27.736 76.1104 20.1465 85.5355 20.1465C94.9606 20.1465 102.601 27.736 102.601 37.0982Z",
    fill: "#8599AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6779 55.7456C97.4057 55.7457 107.78 61.5394 114.095 70.4214C112.382 69.9087 110.564 69.6333 108.683 69.6333C98.3366 69.6334 89.9494 77.9646 89.9494 88.2417C89.9495 90.3143 90.2915 92.3075 90.9211 94.1694H50.8352V90.5874C50.8353 71.3446 66.4351 55.7456 85.6779 55.7456Z",
    fill: "#8599AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124 88.2034C124 96.5371 117.199 103.293 108.809 103.293C100.419 103.293 93.6181 96.5371 93.6181 88.2034C93.6181 79.8696 100.419 73.1138 108.809 73.1138C117.199 73.1138 124 79.8696 124 88.2034Z",
    fill: "#349872"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.728 82.6991C114.272 82.0644 115.231 81.9877 115.87 82.5276C116.509 83.0677 116.586 84.0203 116.043 84.655L106.701 95.5626L101.576 89.5778C101.032 88.9431 101.109 87.9909 101.748 87.4509C102.387 86.9109 103.346 86.9876 103.89 87.6224L106.701 90.9045L113.728 82.6991Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSenderAllowed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/senderAllowed.7b28717af12ceb0931d5584b8030c073.svg";